import HealthyPanel from "./HealthyPanel";

export default HealthyPanel;
